import gameInfo from '../assets/json/gameInfo.json';
import Phaser from 'phaser';
import gameData from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import * as SpinePlugin from 'phaser/plugins/spine/dist/SpineWebGLPlugin.js';

const fonts = [];
for (const k in FontKeys) {
  fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;

/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: ABCyaPhaser.Images.DEFAULT_ATLAS, atlasURL: 'assets/images/' + ABCyaPhaser.Images.DEFAULT_ATLAS + '.json', path: 'assets/images' }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = 'assets/images';

/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: ABCyaPhaser.Audio.DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.ogg', 'assets/sounds/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';

/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.spines = [
  { key: 'fuzzbug', jsonPath: 'assets/spine/fuzzbug.json', atlasPath: 'assets/spine/fuzzbug.atlas' },
  { key: 'fuzzbugSimple0', jsonPath: 'assets/spine/fuzzbugSimple.json', atlasPath: 'assets/spine/fuzzbugSimple.atlas' },
  { key: 'fuzzbugSimple1', jsonPath: 'assets/spine/fuzzbugSimple.json', atlasPath: 'assets/spine/fuzzbugSimple.atlas' },
  { key: 'fuzzbugSimple2', jsonPath: 'assets/spine/fuzzbugSimple.json', atlasPath: 'assets/spine/fuzzbugSimple.atlas' },
  { key: 'fuzzbugSimple3', jsonPath: 'assets/spine/fuzzbugSimple.json', atlasPath: 'assets/spine/fuzzbugSimple.atlas' },
  { key: 'fuzzbugSimple4', jsonPath: 'assets/spine/fuzzbugSimple.json', atlasPath: 'assets/spine/fuzzbugSimple.atlas' },
];

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = (scene) => {
  scene.load.image('Stencil1', 'assets/images/Stencil1.png');
  scene.load.image('Stencil2', 'assets/images/Stencil2.png');
  scene.load.image('Stencil3', 'assets/images/Stencil3.png');
  scene.load.image('Stencil4', 'assets/images/Stencil4.png');
  scene.load.image('Stencil5', 'assets/images/Stencil5.png');
  // insert additional preloader functionality here; scene is the preloader scene
};

(async function handshake() {
  try {
    await ABCyaLib.Environment.instance.doParentHandshake();
  }
  catch (error) {
    console.warn(error);
  }

  console.info('ABCya Game Info:', gameInfo);

  /**
     * Use the fourth argument of initializePhaserGame to override default Phaser config options
     * For example: to use the Spine plugin, the fourth argument should look like this:
     * { 
            configOverrides: {
                plugins: {
                    scene: [
                        { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
                    ]
                }
            }
        }
     */
  ABCyaPhaser.Misc.initializePhaserGame(1024, 768, gameData.scenes, {
    configOverrides: {
      plugins: {
        scene: [
          { key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }
        ]
      }
    }
  });

  // initialize any functionality in abcya_phaser that has a dependency on abcya_lib 
  ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
}());
